import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  private requestCount = 0;
  private _loading = new BehaviorSubject<boolean>(false);
  private showTimeout: any;

  loading$ = this._loading.asObservable();

  show() {
    this.requestCount++;

    if (this.requestCount === 1) {
      this.showTimeout = setTimeout(() => {
        this._loading.next(true);
      }, 150);
    }
  }

  hide() {
    if (this.requestCount > 0) {
      this.requestCount--;
    }

    if (this.requestCount === 0) {
      clearTimeout(this.showTimeout);
      this._loading.next(false);
    }
  }

  reset() {
    this.requestCount = 0;
    clearTimeout(this.showTimeout);
    this._loading.next(false);
  }
}
